import lakuPandaiDigitalTrxTrackerFactory from 'shared_js/modules/tracker/lakuPandaiDigitalTrxTrackerFactory';

import tracker from 'lib/windowTracker';

export default lakuPandaiDigitalTrxTrackerFactory(tracker, {
  eventSchema: 'lakupandai_digital_send_event',
});
